/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import * as Application from 'expo-application';
import * as Battery from 'expo-battery';
import * as Device from 'expo-device';

const is = require('is_js');

const SERVICE_NAME = 'dummy-rest.service';
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

export class DeviceInfoService {
    name = SERVICE_NAME;
    private static instance: DeviceInfoService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new DeviceInfoService();
        }
        return this.instance;
    }
    async init() {}

    getDeviceInfo() {
        const info: any = {
            'X-Device-type': 'mobile',
            'X-Device-brand': Device.brand,
            'X-Device-Manufacturer': Device.manufacturer,
            'X-Device-Model': Device.modelName,
            'X-Device-OS': Device.osName,
            'X-Device-OS-Version': Device.osVersion,
            'X-Device-OS-BuildId': Device.osBuildId,
        };
        return info;
    }

    async getBatteryLevel() {
        return Battery.getBatteryLevelAsync();
    }

    getAppInfo() {
        const info: any = {
            'X-App-Id': Application.applicationId,
            'X-App-Name': Application.applicationName,
            'X-App-Version': Application.nativeApplicationVersion,
            'X-App-Build-Version': Application.nativeBuildVersion,
        };
        return info;
    }

    private report() {
        log?.info(SERVICE_NAME,`⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME,'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
